import { select } from 'redux-saga/effects'

import { types } from 'common/modules/arbiter/actions'

import Loader from 'common/modules/loader'

export default {

    /// need to emit lifecyle/prompt/shown at appropriate times

    // ['LIFECYCLE/PROMPT/SHOWN']: [
    [types.FRAME_SHOW]: [
        {
            event: 'pico.prompt.shown',
            * data(args) {
                if (args.frame === 'pico_prompt') {
                    const loader = yield select(Loader.selectors.topScopeLoader)

                    return { detail: loader }
                }

                return null
            },
        },
    ],
}
